"use client";

import useFetchEvents from "@/hooks/useFetchEvents";
import FeaturedEventInfo from "./components/FeaturedEventInfo/FeaturedEventInfo";
import FeaturedEventDetails from "./components/UpcomingEventDetails/UpcomingEventDetails";

const FeaturedEvents = () => {
  const { allEvents } = useFetchEvents();

  return (
    <section className="container mx-auto max-w-5xl pl-6 md:pl-0">
      <FeaturedEventInfo />
      <FeaturedEventDetails allEvents={allEvents} />
    </section>
  );
};

export default FeaturedEvents;
